<template>
    <div class="billInfo-page">
        <ul class="nav">
            <li :class="[lang]">{{ $t("BillingInformation") }}</li>
        </ul>

        <a-spin size="large" :spinning="loading" wrapperClassName="global-spin-wrapper">
            <div class="subscribe-page">
                <a-card class="main-card">
                    <div class="safeTips" v-if="!form.id">
                        <div class="title1" :class="[lang]">
                            {{ $t("CompleteBillingInfo") }}
                        </div>
                        <div class="cont" :class="[lang]">
                            {{ $t("BillingAddressRequired") }}
                        </div>
                    </div>
                    <div class="content">
                        <div class="left">
                            <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 24 }"
                                :wrapper-col="{ span: 24 }" class="billing-form">
                                <div class="billInfo" style="margin-bottom: 20px">
                                    <div class="section-title">
                                        <span>{{ $t("BillingContact") }}</span>
                                        <!-- <a-button v-if="form.id && !editContact" type="default" class="edit-btn"
                                            @click="editContact = true">{{ $t("Edit") }}</a-button> -->
                                    </div>

                                    <!-- 只读视图 -->
                                    <div class="readonly-view" v-if="form.id && !edit">
                                        <a-row :gutter="16" class="ro-row">
                                            <a-col :xs="24" :sm="12">
                                                <div class="ro-label">{{ $t("UserType") }}</div>
                                                <div class="ro-value">
                                                    <span class="account-tag">{{
                                                        form.is_personal == 2
                                                            ? $t("ForEnterprises")
                                                            : $t("Soloentrepreneur")
                                                    }}</span>
                                                </div>
                                            </a-col>
                                            <a-col :xs="24" :sm="12">
                                                <div class="ro-label">{{ $t("Firstname") }}</div>
                                                <div class="ro-value">{{ form.first_name }}</div>
                                            </a-col>
                                        </a-row>
                                        <a-row :gutter="16" class="ro-row">
                                            <a-col :xs="24" :sm="12">
                                                <div class="ro-label">{{ $t("lastName") }}</div>
                                                <div class="ro-value">{{ form.last_name }}</div>
                                            </a-col>
                                            <a-col :xs="24" :sm="12">
                                                <div class="ro-label">{{ $t("Email") }}</div>
                                                <div class="ro-value">{{ form.email }}</div>
                                            </a-col>
                                        </a-row>
                                        <a-row :gutter="16" class="ro-row">
                                            <a-col :xs="24" :sm="12">
                                                <div class="ro-label">{{ $t("industry") }}</div>
                                                <div class="ro-value">{{ getIndustryName() }}</div>
                                            </a-col>
                                            <a-col :xs="24" :sm="12" v-if="form.is_personal == 2">
                                                <div class="ro-label">{{ $t("Companyname") }}</div>
                                                <div class="ro-value">{{ form.company_name }}</div>
                                            </a-col>
                                        </a-row>
                                        <a-row :gutter="16" class="ro-row" v-if="form.is_personal == 2">
                                            <a-col :xs="24" :sm="12">
                                                <div class="ro-label">{{ $t("Companysize") }}</div>
                                                <div class="ro-value">
                                                    {{ companyList[form.size_id] }}
                                                </div>
                                            </a-col>
                                            <a-col :xs="24" :sm="12">
                                                <div class="ro-label">{{ $t("Positon") }}</div>
                                                <div class="ro-value">{{ getRoleName() }}</div>
                                            </a-col>
                                        </a-row>
                                    </div>

                                    <!-- 编辑/新建视图 -->
                                    <template v-if="!form.id || edit">
                                        <a-row :gutter="16">
                                            <a-col :xs="24" :sm="12">
                                                <a-form-model-item :label="$t('UserType')" prop="is_personal" required
                                                    key="5">
                                                    <a-select v-model="form.is_personal"
                                                        :placeholder="$t('SelectUserType')">
                                                        <a-select-option :class="[lang]" key="1111" value="1">
                                                            {{ $t("Soloentrepreneur") }}
                                                        </a-select-option>
                                                        <a-select-option :class="[lang]" key="1112" value="2">
                                                            {{ $t("ForEnterprises") }}
                                                        </a-select-option>
                                                    </a-select>
                                                </a-form-model-item>
                                            </a-col>
                                            <a-col :xs="24" :sm="12">
                                                <a-form-model-item :label="$t('Firstname')" prop="first_name" key="1"
                                                    required>
                                                    <a-input v-model="form.first_name"
                                                        :placeholder="$t('EnterFirst')" />
                                                </a-form-model-item>
                                            </a-col>
                                        </a-row>
                                        <a-row :gutter="16">
                                            <a-col :xs="24" :sm="12">
                                                <a-form-model-item :label="$t('lastName')" prop="last_name" required
                                                    key="2">
                                                    <a-input v-model="form.last_name"
                                                        :placeholder="$t('EnterLastName')" />
                                                </a-form-model-item>
                                            </a-col>
                                            <a-col :xs="24" :sm="12">
                                                <a-form-model-item key="6" :label="$t('Email')" prop="email" required>
                                                    <a-input v-model="form.email" :placeholder="$t('enterEmail')" />
                                                </a-form-model-item>
                                            </a-col>
                                        </a-row>

                                        <a-row :gutter="16" v-if="form.is_personal == 1">
                                            <a-col :xs="24" :sm="12">
                                                <a-form-model-item key="7" :label="$t('industry')" prop="industry_id"
                                                    required>
                                                    <a-select v-model="form.industry_id"
                                                        :placeholder="$t('selectInstry')">
                                                        <a-select-option :class="[lang]"
                                                            v-for="(item, index) in industryList" :key="index"
                                                            :value="index">
                                                            {{ item }}
                                                        </a-select-option>
                                                    </a-select>
                                                </a-form-model-item>
                                            </a-col>
                                            <a-col :xs="24" :sm="12" v-if="form.industry_id == 15">
                                                <a-form-model-item key="8" :label="$t('Enteryourindustry')"
                                                    prop="industry_desc" required>
                                                    <a-input v-model="form.industry_desc"
                                                        :placeholder="$t('Pleaseenteryourindustry')" />
                                                </a-form-model-item>
                                            </a-col>
                                        </a-row>

                                        <a-row :gutter="16" v-if="form.is_personal == 2">
                                            <a-col :xs="24" :sm="12">
                                                <a-form-model-item key="7" :label="$t('industry')" prop="industry_id"
                                                    required>
                                                    <a-select v-model="form.industry_id"
                                                        :placeholder="$t('selectInstry')">
                                                        <a-select-option :class="[lang]"
                                                            v-for="(item, index) in industryList" :key="index"
                                                            :value="index">
                                                            {{ item }}
                                                        </a-select-option>
                                                    </a-select>
                                                </a-form-model-item>
                                            </a-col>
                                            <a-col :xs="24" :sm="12" v-if="form.industry_id == 15">
                                                <a-form-model-item key="8" :label="$t('Enteryourindustry')"
                                                    prop="industry_desc" required>
                                                    <a-input v-model="form.industry_desc"
                                                        :placeholder="$t('Pleaseenteryourindustry')" />
                                                </a-form-model-item>
                                            </a-col>
                                            <a-col :xs="24" :sm="12" v-else-if="
                                                form.is_personal == 2 && form.industry_id != 15
                                            ">
                                                <a-form-model-item key="3" :label="$t('Companyname')"
                                                    prop="company_name" required>
                                                    <a-input v-model="form.company_name"
                                                        :placeholder="$t('enterCompanyname')" />
                                                </a-form-model-item>
                                            </a-col>
                                        </a-row>

                                        <template v-if="form.is_personal == 2 && form.industry_id == 15">
                                            <a-row :gutter="16">
                                                <a-col :xs="24" :sm="12">
                                                    <a-form-model-item key="3" :label="$t('Companyname')"
                                                        prop="company_name" required>
                                                        <a-input v-model="form.company_name"
                                                            :placeholder="$t('enterCompanyname')" />
                                                    </a-form-model-item>
                                                </a-col>
                                                <a-col :xs="24" :sm="12">
                                                    <a-form-model-item key="4" :label="$t('Companysize')" prop="size_id"
                                                        required>
                                                        <a-select v-model="form.size_id"
                                                            :placeholder="$t('selectcompanysize')">
                                                            <a-select-option :class="[lang]"
                                                                v-for="(item, index) in companyList" :key="index"
                                                                :value="index">{{ item }}</a-select-option>
                                                        </a-select>
                                                    </a-form-model-item>
                                                </a-col>
                                            </a-row>
                                            <a-row :gutter="16">
                                                <a-col :xs="24" :sm="12">
                                                    <a-form-model-item :label="$t('Positon')" prop="role_id" key="9"
                                                        required>
                                                        <a-select v-model="form.role_id"
                                                            :placeholder="$t('selectposition')">
                                                            <a-select-option :class="[lang]"
                                                                v-for="(item, index) in roleList" :key="index"
                                                                :value="index">
                                                                {{ item }}
                                                            </a-select-option>
                                                        </a-select>
                                                    </a-form-model-item>
                                                </a-col>
                                                <a-col :xs="24" :sm="12" v-if="form.role_id == 6">
                                                    <a-form-model-item key="10" :label="$t('Enteryourposition')"
                                                        prop="custom_role" required>
                                                        <a-input v-model="form.custom_role"
                                                            :placeholder="$t('pleaseEnterPos')" />
                                                    </a-form-model-item>
                                                </a-col>
                                            </a-row>
                                        </template>
                                        <template v-if="form.is_personal == 2 && form.industry_id != 15">
                                            <a-row :gutter="16">
                                                <a-col :xs="24" :sm="12">
                                                    <a-form-model-item key="4" :label="$t('Companysize')" prop="size_id"
                                                        required>
                                                        <a-select v-model="form.size_id"
                                                            :placeholder="$t('selectcompanysize')">
                                                            <a-select-option :class="[lang]"
                                                                v-for="(item, index) in companyList" :key="index"
                                                                :value="index">{{ item }}</a-select-option>
                                                        </a-select>
                                                    </a-form-model-item>
                                                </a-col>
                                                <a-col :xs="24" :sm="12">
                                                    <a-form-model-item :label="$t('Positon')" prop="role_id" key="9"
                                                        required>
                                                        <a-select v-model="form.role_id"
                                                            :placeholder="$t('selectposition')">
                                                            <a-select-option :class="[lang]"
                                                                v-for="(item, index) in roleList" :key="index"
                                                                :value="index">
                                                                {{ item }}
                                                            </a-select-option>
                                                        </a-select>
                                                    </a-form-model-item>
                                                </a-col>
                                            </a-row>
                                            <a-row :gutter="16">
                                                <a-col :xs="24" :sm="12" v-if="form.role_id == 6">
                                                    <a-form-model-item key="10" :label="$t('Enteryourposition')"
                                                        prop="custom_role" required>
                                                        <a-input v-model="form.custom_role"
                                                            :placeholder="$t('pleaseEnterPos')" />
                                                    </a-form-model-item>
                                                </a-col>
                                            </a-row>
                                        </template>

                                        <!-- <div class="wrap-btn module-btn" v-if="form.id && editContact">
                                            <a-button type="primary" @click="saveContact" class="submit-btn">{{
                                                $t("Save") }}</a-button>
                                        </div> -->
                                    </template>
                                </div>
                                <div class="billInfo">
                                    <div class="section-title">
                                        <span>{{ $t("BillingAddress") }}</span>
                                        <!-- <a-button v-if="form.id && !editAddress" type="default" class="edit-btn"
                                            @click="editAddress = true">{{
                                                $t("Edit") }}</a-button> -->
                                    </div>

                                    <!-- 只读视图 -->
                                    <div class="readonly-view" v-if="form.id && !edit">
                                        <a-row :gutter="16" class="ro-row">
                                            <a-col :xs="24" :sm="12">
                                                <div class="ro-label">{{ $t("CountryRegion") }}</div>
                                                <div class="ro-value">
                                                    {{ getCountryName(form.country_id) }}
                                                </div>
                                            </a-col>
                                            <a-col :xs="24" :sm="12">
                                                <div class="ro-label">{{ $t("State") }}</div>
                                                <div class="ro-value">{{ form.state }}</div>
                                            </a-col>
                                        </a-row>
                                        <a-row :gutter="16" class="ro-row">
                                            <a-col :xs="24" :sm="12">
                                                <div class="ro-label">{{ $t("City") }}</div>
                                                <div class="ro-value">{{ form.city }}</div>
                                            </a-col>
                                            <a-col :xs="24" :sm="12">
                                                <div class="ro-label">{{ $t("ZipCode") }}</div>
                                                <div class="ro-value">{{ form.zip_code }}</div>
                                            </a-col>
                                        </a-row>
                                        <a-row :gutter="16" class="ro-row">
                                            <a-col :span="24">
                                                <div class="ro-label">{{ $t("StreetAddress") }}</div>
                                                <div class="ro-value">{{ form.street_address }}</div>
                                            </a-col>
                                        </a-row>
                                    </div>

                                    <!-- 编辑/新建视图 -->
                                    <template v-if="!form.id || edit">
                                        <a-row :gutter="16">
                                            <a-col :xs="24" :sm="12">
                                                <a-form-model-item :label="$t('CountryRegion')" prop="country_id"
                                                    required key="5">
                                                    <a-select v-model="form.country_id"
                                                        :placeholder="$t('SelectCountryRegion')">
                                                        <a-select-option :class="[lang]"
                                                            v-for="(item, index) in locationList" :key="index"
                                                            :value="item.id">
                                                            {{ item.show_name }}
                                                        </a-select-option>
                                                    </a-select>
                                                </a-form-model-item>
                                            </a-col>
                                            <a-col :xs="24" :sm="12">
                                                <a-form-model-item key="101" :label="$t('State')" prop="state" required>
                                                    <a-input v-model="form.state"
                                                        :placeholder="$t('PleaseEnterState')" />
                                                </a-form-model-item>
                                            </a-col>
                                        </a-row>
                                        <a-row :gutter="16">
                                            <a-col :xs="24" :sm="12">
                                                <a-form-model-item key="102" :label="$t('StreetAddress')"
                                                    prop="street_address" required>
                                                    <a-input v-model="form.street_address"
                                                        :placeholder="$t('PleaseEnterStreetAddress')" />
                                                </a-form-model-item>
                                            </a-col>
                                            <a-col :xs="24" :sm="12">
                                                <a-form-model-item key="103" :label="$t('City')" prop="city" required>
                                                    <a-input v-model="form.city" :placeholder="$t('PleaseEnterCity')" />
                                                </a-form-model-item>
                                            </a-col>
                                        </a-row>
                                        <a-row :gutter="16">
                                            <a-col :xs="24" :sm="12">
                                                <a-form-model-item key="102" :label="$t('ZipCode')" prop="zip_code"
                                                    required>
                                                    <a-input v-model="form.zip_code"
                                                        :placeholder="$t('PleaseEnterZipCode')" />
                                                </a-form-model-item>
                                            </a-col>
                                        </a-row>

                                        <!-- <div class="wrap-btn module-btn" v-if="form.id && editAddress">
                                            <a-button type="primary" @click="saveAddress" class="submit-btn">{{
                                                $t("Save") }}</a-button>
                                        </div> -->
                                    </template>
                                </div>
                                <div class="wrap-btn">
                                    <a-button type="primary" size="large" v-if="!form.id || edit" @click="submitForm"
                                        class="submit-btn">{{
                                            $t("Save") }}</a-button>

                                    <a-button size="large" v-if="form.id && !edit" @click="editInvoiceInfo"
                                        class="submit-btn">{{
                                            $t("Edit") }}</a-button>
                                </div>
                            </a-form-model>
                        </div>
                    </div>
                </a-card>
            </div>
        </a-spin>
    </div>
</template>

<script>
export default {
    name: "billInfo",
    components: {},
    created() {
        this.info = this.$route.query;
        let { type } = this.info;
        if (type == 3) {
            this.selectedAll = true;
        }

        this.initData();
    },
    i18n: require("./subi18n"),
    data() {
        let that = this;
        return {
            aiType: "",
            edit: false,
            editContact: false,
            editAddress: false,
            selectedAll: false,
            showModal: false,
            loading: false,
            isLtd: false,
            userInfo: {},
            discountCode: "",
            codeInfo: "",
            form: {
                is_personal: "1",
                first_name: "",
                last_name: "",
                country_id: undefined,
                email: "",
                company_name: "",
                size_id: undefined,
                role_id: undefined,
                custom_role: undefined,
                industry_id: null,
                industry_desc: undefined,
                zip_code: "",
                state: "",
                street_address: "",
                city: "",
            },
            rules: {
                first_name: [
                    {
                        required: true,
                        message: that.$t("EnterFirst"),
                        trigger: "blur",
                    },
                ],
                last_name: [
                    {
                        required: true,
                        message: that.$t("EnterLastName"),
                        trigger: "blur",
                    },
                ],
                country_id: [
                    {
                        required: true,
                        message: that.$t("Plaseselectlocation"),
                        trigger: "change",
                    },
                ],
                industry_id: [
                    {
                        required: true,
                        message: that.$t("selectInstry"),
                        trigger: "change",
                    },
                ],
                email: [
                    {
                        required: true,
                        message: that.$t("enterEmail"),
                        trigger: "blur",
                    },
                    {
                        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: that.$t("correctemial"),
                        trigger: "blur",
                    },
                ],
                company_name: [
                    {
                        required: true,
                        message: that.$t("enterCompanyname"),
                        trigger: "blur",
                    },
                ],
                size_id: [
                    {
                        required: true,
                        message: that.$t("selectcompanysize"),
                        trigger: "change",
                    },
                ],
                role_id: [
                    {
                        required: true,
                        message: that.$t("selectposition"),
                        trigger: "change",
                    },
                ],
                custom_role: [
                    {
                        required: true,
                        message: that.$t("pleaseEnterPos"),
                        trigger: "blur",
                    },
                ],
                industry_desc: [
                    {
                        required: true,
                        message: that.$t("Pleaseenteryourindustry"),
                        trigger: "blur",
                    },
                ],
                street_address: [
                    {
                        required: true,
                        message: that.$t("PleaseEnterStreetAddress"),
                        trigger: "blur",
                    },
                ],
                zip_code: [
                    {
                        required: true,
                        message: that.$t("PleaseEnterZipCode"),
                        trigger: "blur",
                    },
                ],
                state: [
                    {
                        required: true,
                        message: that.$t("PleaseEnterState"),
                        trigger: "blur",
                    },
                ],
                city: [
                    {
                        required: true,
                        message: that.$t("PleaseEnterCity"),
                        trigger: "blur",
                    },
                ],
            },
            currentInfo: [],
            roleList: [],
            companyList: [],
            locationList: [],
            planInfo: {},
            industryList: {},
            info: {},
        };
    },
    watch: {
        lang() {
            this.getPublicList();
        },
    },
    methods: {
        editInvoiceInfo() {
            this.edit = true;
        },
        getCountryName(country_id) {
            const country = this.locationList.find((item) => item.id === country_id);
            return country ? country.show_name : "";
        },
        getIndustryName() {
            const id = this.form.industry_id;
            if (id == 15) {
                return this.form.industry_desc || "";
            }
            return (this.industryList && this.industryList[id]) || "";
        },
        getRoleName() {
            const id = this.form.role_id;
            if (id == 6) {
                return this.form.custom_role || "";
            }
            return (this.roleList && this.roleList[id]) || "";
        },
        // 保存 Billing Contact 模块
        saveContact() {
            const contactFields = [
                "is_personal",
                "first_name",
                "last_name",
                "email",
                "industry_id",
                "industry_desc",
                "company_name",
                "size_id",
                "role_id",
                "custom_role",
            ];
            this.validateAndSubmit(contactFields, () => {
                this.editContact = false;
            });
        },
        // 保存 Billing Address 模块
        saveAddress() {
            const addressFields = [
                "country_id",
                "state",
                "street_address",
                "city",
                "zip_code",
            ];
            this.validateAndSubmit(addressFields, () => {
                this.editAddress = false;
            });
        },
        // 按字段校验后调用保存接口
        validateAndSubmit(fields, onSuccess) {
            const formRef = this.$refs.form;
            if (!formRef || typeof formRef.validateField !== "function") {
                this.$message && this.$message.error(this.$t("formLoadError"));
                return;
            }
            formRef.validate((valid) => {
                if (valid) {
                    this.doSubmit(onSuccess);
                }
            })

        },
        // 实际调用保存接口（保留原 submitForm 全量提交逻辑）
        doSubmit(onSuccess) {
            this.loading = true;
            this.writeLog("plan", "page_click", "pay_now");
            let { duration_type } = this.$route.query;
            let { country_id, size_id, industry_id, role_id, id } = this.form;
            let params = {};
            if (id) {
                params.payment_ext_id = id;
            }
            if (this.planInfo.discount_code) {
                params.discount_code = this.planInfo.discount_code;
            }
            let url = "/payment/create_ext_info";
            if (this.form.id) {
                url = "/payment/update_ext_info";
            }
            this.$axios(
                url,
                {
                    ...this.$route.query,
                    ...this.form,
                    duration_type: parseInt(duration_type),
                    campaign_type: this.selectedAll
                        ? null
                        : this.aiType == "1"
                            ? 1
                            : this.aiType == "2"
                                ? 2
                                : null,
                    subscription_plan_id: this.planInfo.id,
                    industry_id: industry_id ? parseInt(industry_id) : undefined,
                    role_id: role_id ? parseInt(role_id) : null,
                    country_id: country_id ? parseInt(country_id) : null,
                    size_id: size_id ? parseInt(size_id) : null,
                    is_personal: parseInt(this.form.is_personal),
                    ...params,
                },
                "post",
            )
                .then((res) => {
                    this.loading = false;
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                        if (res.data && res.data.id) {
                            this.form.id = res.data.id;
                        }
                        if (typeof onSuccess === "function") {
                            onSuccess();
                        }
                    }
                })
                .catch((e) => {
                    console.log(e);
                    this.loading = false;
                });
        },

        initData() {
            this.loading = true;

            this.getPublicList();
        },
        getPublicList() {
            const role = this.$axios(
                "/public/custom_role_config",
                {
                    landing_page: 1,
                },
                "post",
            );
            const company = this.$axios("/public/company_size_config", {}, "post");
            const location = this.$axios("/public/country_config", {}, "post");
            const industry = this.$axios("/public/industry_config", {}, "post");
            const info = this.$axios("/payment/ext_info_list", {}, "post");
            Promise.all([role, company, location, industry, info]).then(
                ([res1, res2, res3, res4, res5]) => {
                    this.loading = false;
                    this.roleList = res1.data;
                    this.companyList = res2.data;
                    this.locationList = res3.data;
                    this.industryList = res4.data;
                    let info = res5.data || [];
                    info = info[0] || {};

                    this.userInfo = info;
                    let { industry_id, role_id, size_id } = info;
                    industry_id = industry_id ? industry_id : 0;
                    this.edit = info.city ? false : true;
                    // 有 id 表示已保存过，两个模块默认只读
                    this.editContact = false;
                    this.editAddress = false;

                    this.form = {
                        ...this.form,
                        ...info,
                        industry_id: industry_id + "",
                        role_id: role_id ? role_id + "" : null,
                        size_id: size_id ? size_id + "" : null,
                        is_personal:
                            info.is_personal == 1 || info.is_personal == 2
                                ? info.is_personal + ""
                                : this.form.is_personal,
                    };
                },
            );
        },

        submitForm() {
            // 校验前先判断ref是否存在且有validate方法
            const formRef = this.$refs.form;

            if (formRef && typeof formRef.validate === "function") {
                formRef.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        this.writeLog("plan", "page_click", "pay_now");
                        let { duration_type } = this.$route.query;
                        let { country_id, size_id, industry_id, role_id, id } = this.form;
                        let params = {};
                        if (id) {
                            params.payment_ext_id = id;
                        }

                        if (this.planInfo.discount_code) {
                            params.discount_code = this.planInfo.discount_code;
                        }
                        // console.log(this.$route.query.upgrade_free);
                        let url = "/payment/create_ext_info";
                        if (this.form.id) {
                            url = "/payment/update_ext_info";
                        }
                        this.$axios(
                            url,
                            {
                                ...this.$route.query,
                                ...this.form,
                                duration_type: parseInt(duration_type),
                                campaign_type: this.selectedAll
                                    ? null
                                    : this.aiType == "1"
                                        ? 1
                                        : this.aiType == "2"
                                            ? 2
                                            : null,
                                subscription_plan_id: this.planInfo.id,
                                industry_id: industry_id ? parseInt(industry_id) : undefined,
                                role_id: role_id ? parseInt(role_id) : null,
                                country_id: country_id ? parseInt(country_id) : null,
                                size_id: size_id ? parseInt(size_id) : null,
                                is_personal: parseInt(this.form.is_personal),
                                ...params,
                            },
                            "post",
                        )
                            .then((res) => {
                                this.loading = false;
                                if (res.code == 200) {
                                    this.$message.success(res.msg);
                                }
                            })
                            .catch((e) => {
                                console.log(e);
                                this.loading = false;
                            });
                        // const guest_id = this.generateUUIDNoDash();
                        // sessionStorage.setItem("guest_id", guest_id);
                        // let { industry_id, role_id, country_id, size_id } = this.form;

                        // let params = {
                        //   ...this.form,
                        //   ...values,
                        //   campType: this.info.campType,
                        //   isLtd: this.isLtd,
                        //   url: this.info.url,
                        //   guest_id,
                        //   industry_id: industry_id ? parseInt(industry_id) : undefined,
                        //   role_id: role_id ? parseInt(role_id) : null,
                        //   country_id: country_id ? parseInt(country_id) : null,
                        //   size_id: size_id ? parseInt(size_id) : null,
                        // };

                        // let { path } = this.$route;
                        // let url = "/public/create_guest_activation_order";
                        // if (path == "/subscribeLtd") {
                        //   url = "/public/create_guest_ltd_order";
                        // }
                        // this.$axios.post(url, params).then((res) => {
                        //   this.loading = false;
                        //   if (res.code == 200) {
                        //     this.loading = false;
                        //     location.href = res.data.payment_url;
                        //   }
                        // });
                    } else {
                        // 校验失败
                        return false;
                    }
                });
            } else {
                // 兼容性提示
                this.$message && this.$message.error(this.$t("formLoadError"));
            }
        },
    },
};
</script>
<style>
.ant-spin-nested-loading>div>.ant-spin {
    height: 100vh;
}

.ant-spin-nested-loading>div>.ant-spin .ant-spin-dot {
    position: fixed;
}
</style>
<style lang="less" scoped>
.nav {
    width: 100%;
    padding-top: 7px;
    padding-left: 30px;
    border-top: #d1d1d1 solid 1px;

    li {
        height: 42px;
        line-height: 42px;
        padding: 0 12px;
        margin-right: 88px;
        display: inline-block;
        font-weight: bold;
        font-size: 16px;
        color: #000000;

        a {
            color: #000;
        }

        border-bottom: #fff 2px solid;
    }

    .selected {
        border-bottom: #0e756a 2px solid;

        a {
            font-weight: bold;
        }
    }

    background: #ffffff;
    box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.1);
}

.wrap-btn {
    margin-top: 24px;
    display: flex;
    justify-content: center;
}

.nav,
.back {
    left: 254px;
    position: fixed;
    top: 64px;
    right: 0;
    z-index: 200;
}

.back {
    border-top: #d1d1d1 solid 1px;
    color: #0e756a;
    cursor: pointer;
    height: 50px;
    line-height: 50px;
    padding-left: 30px;
    background: #fff;
}

.subscribe-page {
    min-height: 100vh;

    .safeTips {
        border-radius: 10px;
        background-color: rgba(255, 246, 234, 1);
        font-size: 14px;
        font-family: PingFangSC-regular;
        border: 1px solid rgba(251, 192, 35, 1);
        padding: 19px 17px;

        .title1 {
            height: 24px;
            line-height: 24px;
            color: rgba(16, 16, 16, 1);
            font-size: 17px;
            text-align: left;
            font-family: PingFangSC-regular;
            margin-bottom: 13px;
        }

        .cont {
            line-height: 20px;
            color: rgba(28, 38, 62, 0.52);
            font-size: 14px;
            text-align: left;
            font-family: PingFangSC-regular;
        }
    }

    .edit-link {
        color: #1890ff;
    }

    .main-card {
        // width: 1200px;
        // max-width: 98vw;
        // margin: 0 auto;
        margin: 70px 30px 20px 30px;
        // margin-top: 112px;
        // margin-bottom: 35px;
        padding: 10px;
        border-radius: 4px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
        background: #fff;
        border: none;
        height: 100vh;

        // /deep/ .ant-card-body {
        //   padding: 0;
        // }
        @media (max-width: 900px) {
            width: 100vw;
            padding: 16px 0;
            border-radius: 0;
            box-shadow: none;
            margin-top: 56px;

            /deep/.ant-card-body {
                padding: 16px;
            }
        }

        @media (max-width: 600px) {
            padding: 8px 0;
            margin-top: 56px;

            /deep/.ant-card-body {
                padding: 16px;
            }
        }
    }

    .steps {
        margin-bottom: 40px;

        @media (max-width: 600px) {
            margin-bottom: 20px;

            .ant-steps-item-title {
                font-size: 12px;
            }

            .ant-steps-item {
                padding: 0 2px;
            }
        }
    }

    .content {
        display: flex;
        gap: 40px;

        @media (max-width: 900px) {
            flex-direction: column;
            gap: 16px;
        }

        @media (max-width: 600px) {
            gap: 4px;
            padding: 0 4px;
        }

        .left {
            flex: 2;
            min-width: 0;

            @media (max-width: 900px) {
                border-right: none;
                padding-right: 0;
                border-bottom: 1px solid #f0f0f0;
                padding-bottom: 24px;
                margin-bottom: 16px;
            }

            @media (max-width: 600px) {
                padding-bottom: 8px;
                margin-bottom: 4px;
            }

            /deep/.ant-alert-info {
                background-color: #e6f7ff;
                border: 0.02667rem solid #91d5ff;
            }

            .alertInfo {
                margin-bottom: 16px;
                padding: 12px;

                a {
                    color: #0e756a;
                }
            }

            .section-title {
                font-weight: 600;
                margin-bottom: 8px;
                font-size: 17px;
                color: #222;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .edit {
                    color: #0e756a;
                }

                .edit-btn {
                    border-radius: 6px;
                    height: 32px;
                    padding: 0 18px;
                    font-size: 14px;
                    color: #222;
                    border-color: #d9d9d9;
                }

                @media (max-width: 600px) {
                    font-size: 14px;
                    margin-bottom: 4px;
                }
            }

            .readonly-view {
                margin-top: 8px;
                margin-bottom: 8px;

                .ro-row {
                    margin-bottom: 16px;
                }

                .ro-label {
                    color: rgba(0, 0, 0, 0.45);
                    font-size: 13px;
                    margin-bottom: 4px;
                    letter-spacing: 0.3px;
                }

                .ro-value {
                    color: #222;
                    font-size: 15px;
                    font-weight: 500;
                    word-break: break-word;
                }

                .account-tag {
                    display: inline-block;
                    background: #e6f4f1;
                    color: #0e756a;
                    padding: 4px 12px;
                    border-radius: 4px;
                    font-size: 14px;
                    font-weight: 500;
                }
            }

            .module-btn {
                margin-top: 16px;
                justify-content: flex-end;
            }

            .mb16 {
                margin-bottom: 16px;

                @media (max-width: 600px) {
                    margin-bottom: 8px;
                }
            }

            .mb24 {
                margin-bottom: 24px;
                display: flex;

                @media (max-width: 600px) {
                    margin-bottom: 8px;
                    flex-direction: column;
                }

                /deep/ .ant-row {
                    display: flex;
                    flex-wrap: wrap;
                }

                .ai-card-col {
                    @media (min-width: 601px) {
                        display: flex;
                    }

                    @media (max-width: 600px) {
                        margin-bottom: 8px;

                        &:last-child {
                            margin-bottom: 0;
                        }
                    }

                    /deep/ .ant-card {
                        @media (min-width: 601px) {
                            width: 100%;
                        }
                    }
                }
            }

            .selected {
                border: 1px solid #52c41a;
                background: #f6ffed;
                transition: border 0.2s, background 0.2s;
            }

            .desc {
                color: #888;
                font-size: 13px;
                margin-top: 4px;

                @media (max-width: 600px) {
                    font-size: 12px;
                }
            }

            .billing-form {
                margin-top: 16px;

                @media (max-width: 600px) {
                    margin-top: 4px;
                }

                @media (min-width: 600px) {
                    .ant-form-item-label {
                        padding-right: 16px;
                    }
                }

                .ant-form-item-label>label {
                    font-size: 15px;

                    @media (max-width: 600px) {
                        font-size: 13px;
                    }
                }

                .ant-input,
                .ant-select-selector {
                    font-size: 15px;

                    @media (max-width: 600px) {
                        font-size: 13px;
                        height: 36px;
                    }
                }
            }
        }
    }

    @media (max-width: 600px) {
        // padding: 8px 0 8px 0;
    }
}

/deep/.ant-steps-item-finish .ant-steps-item-title {
    color: #0e756a !important;
}

/deep/.ant-checkbox-disabled+span {
    color: #000 !important;
}

.disabled {
    cursor: not-allowed;

    /deep/.ant-checkbox {
        cursor: not-allowed;
    }

    .ant-checkbox-wrapper,
    input {
        cursor: not-allowed !important;
    }
}
</style>
